<template>
  <div
    class="custom-v-select-wrapper-chatbot"
    :class="{
      'custom-v-select-focus':
        isFocused || (internalValue && internalValue.length > 0),
      'custom-v-select-error': props.isError,
      'custom-v-select-disabled': props.disabled,
      'is-hide-dropdown': !props.isShowDropdownIcon,
      'is-search-icon': props.isSearchIcon,
      'is-no-prefix-icon': props.isNoPrefixIcon,
      'is-icon-option': props.isIconOption,
    }"
  >
    <v-select
      ref="selectInput"
      v-model="internalValue"
      :options="props.options"
      :label="props.labelKey"
      :reduce="reduceFn"
      :placeholder="!isFocused ? props.label : ''"
      :multiple="props.multiple"
      :searchable="true"
      :clearable="props.isClearable"
      class="custom-v-select"
      @focusin="handleFocus"
      @focusout="handleBlur"
      @input="handleInput"
      :disabled="props.disabled"
      @update:modelValue="handleChange"
      :selectable="isOptionSelectable"
    >
      <template #option="option">
        <div
          v-if="option.isGroup"
          class="option-group-label"
          @mousedown.prevent
        >
          <span :title="option.text">{{ option.text }}</span>
        </div>
        <div v-else>{{ option.text }}</div>
      </template>

      <template #selected-option="option">
        {{ option.text }}
      </template>

      <template #open-indicator="{ attributes }">
        <span v-bind="attributes">
          <img
            class="cursor-pointer"
            src="/images/icons/ic-indicator-thin.svg"
          />
        </span>
      </template>
      <template v-if="props.isIconOption" #option="{ title, text, icon }">
        <div class="option-item">
          <img :src="icon" alt="" class="option-item-icon" />
          <span
            class="option-item-text line-clamp-1 text-ellipsis"
            :title="text"
          >
            {{ text }}
          </span>
        </div>
      </template>
    </v-select>
    <!-- <label
      v-if="isFocused || (internalValue && internalValue.length > 0)"
      class="custom-floating-label"
    >
      {{ props.label }}
    </label> -->
  </div>
</template>
<script setup>
const componentName = 'SelectChatbot';

import { ref, watch } from 'vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
  options: {
    type: Array,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  labelKey: {
    type: String,
    default: 'text',
  },
  valueKey: {
    type: String,
  },
  multiple: {
    type: Boolean,
    default: false,
  },
  isError: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isShowDropdownIcon: {
    type: Boolean,
    default: true,
  },
  isClearable: {
    type: Boolean,
    default: true,
  },
  isSearchIcon: {
    type: Boolean,
    default: false,
  },
  isNoPrefixIcon: {
    type: Boolean,
    default: false,
  },
  isIconOption: {
    type: Boolean,
    default: false,
  },
  onChange: {
    type: Function,
    default: () => {},
  },
});

const emit = defineEmits(['update:modelValue']);

const internalValue = ref();
const isFocused = ref(false);

onMounted(() => {
  if (props.multiple) {
    if (props.modelValue.length) {
      internalValue.value = [...props.modelValue];
    } else if (props.valueKey !== undefined) {
      internalValue.value = props.valueKey;
    }
  } else {
    if (props.modelValue.length) {
      internalValue.value = props.modelValue;
    } else if (props.valueKey !== undefined) {
      internalValue.value = props.valueKey;
    }
  }
});

const reduceFn = (option) => {
  return option.value;
};

const handleChange = (value) => {
  props.onChange(value);
};

const handleInput = (value) => {
  // console.log('handleInput', value);
  // if (value !== null && value !== undefined) {
  //   internalValue.value = value;
  // }
};

const handleFocus = () => {
  if (!props.disabled) {
    isFocused.value = true;
    const dropdownToggle = document.querySelector('.vs__dropdown-toggle');
    const dropdownMenu = document.querySelector('.vs__dropdown-menu');

    if (dropdownToggle) {
      dropdownToggle.classList.add('custom-dropdown-toggle-focus');
    }

    if (dropdownMenu) {
      dropdownMenu.classList.add('custom-dropdown-menu-focus');
    }
    if (props.isError) {
      dropdownToggle.classList.remove('custom-dropdown-toggle-focus');
    }
  }
};

const handleBlur = () => {
  setTimeout(() => {
    if (!props.disabled) {
      isFocused.value = false;
      const dropdownToggle = document.querySelector('.vs__dropdown-toggle');
      const dropdownMenu = document.querySelector('.vs__dropdown-menu');

      if (dropdownToggle) {
        dropdownToggle.classList.remove('custom-dropdown-toggle-focus');
      }

      if (dropdownMenu) {
        dropdownMenu.classList.remove('custom-dropdown-menu-focus');
      }

      if (props.isError) {
        dropdownToggle.classList.remove('custom-dropdown-toggle-focus');
      }
    }
  }, 100);
};

const isOptionSelectable = (option) => {
  return !option.isGroup;
};

watch(
  internalValue,
  (newValue, oldValue) => {
    // emit('update:modelValue', newValue);
    // props.onChange(newValue);
  },
  {
    deep: true,
  }
);

watch(
  () => props.valueKey,
  (newValue) => {
    console.log('newValue', newValue);
    internalValue.value = newValue;
  },
  {
    deep: true,
  }
);
</script>
<style lang="scss">
.custom-v-select-wrapper-chatbot {
  text-align: left;
  position: relative;
  width: 100%;

  &.is-search-icon {
    .custom-v-select {
      .vs__selected-options {
        .vs__selected {
          margin: 8px 4px 0 32px !important;
          border: none;
        }

        .vs__search {
          padding-left: 32px;
          color: $semantic-color-text-form-placeholder;
        }
        &:after {
          position: absolute;
          content: '';
          background-color: transparent;
          background-size: cover;
          width: 24px;
          height: 24px;
          background-repeat: no-repeat;
          background-image: url('/images/icons/ic-search-outline-gray.svg');
          color: #ffffff;
          font-weight: 500;
          font-size: 16px;
          line-height: 16px;
          top: 75%;
          transform: translateY(-75%);
        }
      }
    }
  }

  &.is-no-prefix-icon {
    .custom-v-select {
      .vs__selected-options {
        .vs__selected {
          margin: 0 !important;
          border: none;
        }

        .vs__search {
          margin-left: 8px;
          padding-left: 8px;
          color: $semantic-color-text-form-placeholder;
        }
        &:after {
          position: absolute;
          content: '';
          background-color: transparent;
          color: #ffffff;
          font-weight: 500;
          font-size: 16px;
          line-height: 16px;
          top: 75%;
          transform: translateY(-75%);
        }
      }
    }
  }

  &.is-icon-option {
    .custom-v-select {
      .vs__dropdown-option {
        margin-top: 8px;
        .option-item {
          display: flex;
          gap: 8px;
          overflow: hidden;

          .option-item-icon {
          }

          .option-item-text {
            font-family: $typography-font-family-primary;
            font-size: $typography-font-size-sm;
            white-space: break-spaces;
            line-heiht: $typography-line-height-sm;
            color: #475569;
          }

          &:hover {
            .option-item-text {
              color: white;
            }
          }
        }
      }
      /* .vs__selected-options {
      } */
    }
  }
}

.custom-v-select {
  width: 100%;
  position: relative;
  height: 40px;
  border: 1px solid #E8E7EB;
  border-radius: 9999px;
  position: relative;

  .vs__selected-options {
    position: relative;
    height: 100%;

    .vs__selected {
      margin: 0 !important;
      border: none;
      position: absolute;
      left: 64px;
      top: 50%;
      transform: translate(0, -50%);
      color: #6b7280 !important;
    }

    .vs__search {
      margin: 0 0 0 64px;
      height: 100%;
      color: #6b7280;
    }
    &:after {
      position: absolute;
      content: 'Model';
      background: #330066;
      border-radius: 9999px;
      width: 57px;
      height: 32px;
      color: #ffffff;
      font-weight: 500;
      font-size: 16px;
      line-height: 16px;
      z-index: 9;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .vs__dropdown-toggle {
    position: absolute;
    border: none;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
    height: 100%;
    padding: 0;

    .vs__actions {
      padding-top: 0;
    }
  }
}

.custom-floating-label {
  position: absolute;
  left: 12px;
  font-size: 14px;
  padding: 0 4px;
  pointer-events: none;
  transform: translateY(0);
  z-index: 1;
}

.custom-v-select-wrapper-chatbot.custom-v-select-focus .custom-floating-label,
.custom-v-select-wrapper-chatbot .custom-floating-label {
  top: -3px;
  color: $semantic-color-text-form-label;
  background: $semantic-color-form-background;
  transform: translateY(-50%);
  font-family: $typography-font-family-primary;
  font-size: $semantic-text-body-md-font-size;
  font-weight: 400;
  line-height: $semantic-text-body-md-line-height-leading-none;
  text-align: left;
}

.custom-v-select-wrapper-chatbot .custom-v-select .vs__selected-options {
  position: relative;
  z-index: 0;
}

.custom-v-select-wrapper-chatbot {
  &.is-hide-dropdown {
    .custom-v-select .vs__actions {
      display: none;
      padding-top: 0;
    }
  }
}

.custom-v-select-wrapper-chatbot .custom-v-select .vs__input {
  font-family: $typography-font-family-primary;
  font-size: $semantic-text-body-md-font-size;
  font-weight: 400;
  line-height: $semantic-text-body-md-line-height-leading-none;
  text-align: left;
  padding: 16px 12px 24px;
  box-sizing: border-box;
}

.custom-v-select-wrapper-chatbot .custom-v-select .vs__dropdown-menu {
  /* border: 2px solid #ccc;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); */
  overflow-y: auto;
  /* max-height: calc(100vh - 600px); */
  max-height: 247px;
  box-shadow: 0px 0px 10px 0px #0000001a;
  border-radius: 12px;
  border: none;
  padding: 8px;
}

.custom-v-select-wrapper-chatbot .custom-v-select .vs__dropdown-menu {
  margin-top: 10px;
  border-radius: var(--vs-border-radius);
}

.custom-v-select-wrapper-chatbot
  .custom-v-select
  .custom-dropdown-toggle-focus {
  /* border: 2px solid;
  border-color: #474b95; */
  border: none;

  .vs__selected {
    display: none;
  }
}

.custom-v-select-wrapper-chatbot .custom-v-select .vs__dropdown-toggle {
  font-family: $typography-font-family-primary;
  font-size: $semantic-text-body-md-font-size;
  font-weight: 400;
  line-height: $semantic-text-body-md-line-height-leading-none;
  text-align: left;
  cursor: text;
}

.custom-v-select-wrapper-chatbot .custom-v-select .vs__selected {
  font-family: $typography-font-family-primary;
  font-size: $semantic-text-body-md-font-size;
  font-weight: 400;
  line-height: $semantic-text-body-md-line-height-leading-none;
  text-align: left;
  /* display: flex; */
  align-items: center;
  background: var(--vs-selected-background);
  border-radius: var(--vs-border-radius);
  color: var(--vs-selected-color);
  line-height: var(--vs-line-height);
  margin: 5px 8px 6px;
  padding: 0 0.25em;
  z-index: 10;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.custom-v-select-error .vs__dropdown-toggle {
  border: 2px solid;
  border-color: $semantic-color-status-error-border-validation;
}

.custom-v-select-wrapper-chatbot
  .custom-v-select-error
  .custom-dropdown-toggle-error-focus {
  border: 2px solid;
  border-color: $semantic-color-status-error-border-validation;
}

.vs--disabled {
  background: #E8E7EB;

  .vs__dropdown-toggle,
  .vs__open-indicator,
  .vs__search {
    background: transparent;
  }
}

.vs__dropdown-option {
  overflow: hidden;
  text-overflow: ellipsis;
}

.vs__dropdown-option--highlight {
  background: #9671d0;
  color: var(--vs-dropdown-option--active-color);
  border-radius: 12px;
}
</style>
